<template>
  <div
    ref="keen"
    class="keen-slider w-full mb-6 mr-32 md:mr-16 2xl:mr-20 overflow-visible"
  >
    <div
      v-for="(person, index) in team"
      :key="index"
      class="keen-slider__slide flex"
    >
      <TeamMember v-bind="person" />
    </div>
  </div>
</template>

<script>
import KeenSlider from 'keen-slider';

import TeamMember from '~/components/TeamMember';

export default {
  name: 'TeamSlider',
  components: {
    TeamMember,
  },
  props: {
    go: {
      default: null,
      type: String,
    },
    team: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      keen: null,
    };
  },
  watch: {
    go(go) {
      if (this.keen && ['<', '>'].includes(go)) {
        this.keen[go === '<' ? 'prev' : 'next']();
      }
    },
  },
  mounted() {
    this.keen = new KeenSlider(this.$refs.keen, {
      breakpoints: {
        '(min-width: 768px)': {
          slidesPerView: 3,
          spacing: 32,
          centered: false,
        },
        '(min-width: 1024px)': {
          slidesPerView: 4,
          spacing: 32,
          centered: false,
        },
        '(min-width: 1280px)': {
          slidesPerView: 4,
          spacing: 48,
          centered: false,
        },
        '(min-width: 1440px)': {
          slidesPerView: 4,
          spacing: 80,
          centered: false,
        },
      },
      slidesPerView: 2,
      centered: true,
      duration: 750,
      mode: 'free-snap',
    });
  },
};
</script>
